import React from "react";
import { Link } from "react-router-dom";
import "./Header2.css";
import logo from "../../Images/Logo/White Background .png";
import text from "../../Images/Logo/IceGemsText.png";
import Nav from "./Nav";

const Header2: React.FC = () => {
  return (
    <header className="navHeader">
      <div className="logo">
        <Link to={"/"}>
          <img
            loading="lazy"
            src={logo}
            className="logoImage"
            alt="Ice Gems logo"
          />
          <img
            loading="lazy"
            src={text}
            className="logoText"
            alt="Ice Gems logo"
          />
        </Link>
      </div>
      <Nav />
    </header>
  );
};

export default Header2;
